// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"MoreButton--moreButton--2cWJF","placeholderAnim":"MoreButton--placeholderAnim--36p82"};